meetingTestrtc.controller('meetingTestrtcCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    'logService',
    'connectivityService',
    'storageService',
    'meetingService',
    'attendeeService',
    'configService',
    '$window',
    function (
        $rootScope,
        $scope,
        $timeout,
        logService,
        connectivityService,
        storageService,
        meetingService,
        attendeeService,
        configService,
        $window
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('meetingTestrtcCtrl');

        self.close = close;

        init();

        ////////////////////////

        function init() {
            logger.log('init', 'called');

            $timeout(function () {
                $window.$('#meeting-testrtc').draggable({
                    handle: $window.$('#meeting-testrtc .handle')
                });
                const turnServers = connectivityService
                    .getIceServers()
                    .filter(s => (s.urls || s.url).startsWith('turn:'));
                const stunServers = connectivityService
                    .getIceServers()
                    .filter(s => (s.urls || s.url).startsWith('stun:'));
                const params = {};
                if (turnServers.length > 0) {
                    Object.assign(params, {
                        turnURI: turnServers.map(s => s.urls).join(','),
                        turnCredential: turnServers[0].credential,
                        turnUsername: turnServers[0].username
                    });
                }
                if (stunServers.length > 0) {
                    Object.assign(params, {
                        stunURI: stunServers.map(s => s.urls).join(',')
                    });
                }

                const audioSource = storageService.get('audio-device');
                const videoSource = storageService.get('video-device');
                if (audioSource) {
                    params.audioSource = audioSource;
                }
                if (videoSource) {
                    params.videoSource = videoSource;
                }

                params.metadata = JSON.stringify({
                    meeting: meetingService.getMeetingCode() || null,
                    attendee: attendeeService.getAttendantId() || null,
                    name: attendeeService.getScreenName() || null
                });

                const testrtcUrl =
                    '/lib/testrtc/index.html?show=all&' +
                    (configService.getValue('enableTestrtc') == 'auto' ? 'start=auto&' : '') +
                    Object.entries(params)
                        .map(([n, v]) => `${n}=${encodeURIComponent(v)}`)
                        .join('&');
                logger.log('iframe url=' + testrtcUrl);
                const iframe = $window.$('#meeting-testrtc iframe')[0];
                iframe.style.visibility = '';
                iframe.onload = function () {
                    $timeout(function () {
                        // inject css and js to change some behavior.
                        const doc = iframe.contentDocument;
                        if (doc) {
                            doc.head.innerHTML += `<style type="text/css">
                                body { margin: 0; }
                                paper-toolbar.titlebar { margin: 0 !important; background-color: #0098DB; }
                                footer { display: none; }
                                testrtc-main .titlebar span { visibility: hidden; }
                                testrtc-main #startButton { visibility: visible; }
                                paper-dialog { overflow: auto; }
                                paper-dialog#settings > div.section:nth-child(3) { display: none; }
                                paper-dialog#settings > div.section:nth-child(4) { display: none; }
                                paper-dialog#settings > div.section:nth-child(5) { display: none; }
                                report-dialog#bugreport paper-dialog#mainDialog > :nth-child(5) { display: none; }
                            </style>`;
                            //  testrtc-main > gum-dialog:nth-child(1) { visibility: hidden; }

                            const buttons = doc.querySelector(
                                'report-dialog#bugreport paper-dialog#mainDialog div.buttons'
                            );
                            const download = doc.querySelector(
                                'report-dialog#bugreport paper-dialog#mainDialog div.buttons > paper-button'
                            );
                            const textarea = doc.querySelector(
                                'report-dialog#bugreport paper-dialog#mainDialog paper-textarea'
                            );

                            if (buttons && download) {
                                const submit = doc.createElement('paper-button');
                                submit.innerText = 'Submit Report';
                                //download.style.display = 'none';

                                buttons.insertBefore(submit, download);

                                submit.addEventListener('click', function (event) {
                                    event.preventDefault();
                                    event.stopImmediatePropagation();

                                    logger.log('submit report clicked');
                                    const win = iframe.contentWindow;

                                    var fileContent = win.report.generate(textarea?.value);

                                    if (meetingService.showTestrtc) {
                                        // launched on start, save for later
                                        meetingService._reportTestrtc = fileContent;
                                    } else {
                                        // send to msgflow now.
                                        $rootScope.$broadcast('send-msgflow-event', {
                                            name: 'testrtc-report',
                                            data: fileContent
                                        });
                                    }

                                    // compress to reduce size of logged data
                                    const stream = new Blob([JSON.stringify(fileContent)], {
                                        type: 'application/json'
                                    }).stream();
                                    const compressed = stream.pipeThrough(new CompressionStream('gzip'));
                                    const response = new Response(compressed);
                                    response.blob().then(blob => {
                                        blob.arrayBuffer().then(buffer => {
                                            const base64 = btoa(String.fromCharCode(...new Uint8Array(buffer)));
                                            logger.info(
                                                'TESTRTC report, gzip/b64',
                                                fileContent.length,
                                                base64.length,
                                                base64
                                            );
                                        });
                                    });

                                    // if (fileContent && fileContent.length > 30000) { // split into multiple to avoid cutoff
                                    //     for (let i=0; i<fileContent.length; i += 30000) {
                                    //         logger.info(`TESTRTC report, part ${i+1}`, fileContent.substring(i, i+30000));
                                    //     }
                                    // } else {
                                    //     logger.info('TESTRTC report', fileContent); // this gets cutoff in log.
                                    // }

                                    // var content = encodeURIComponent(fileContent);
                                    // var link = document.createElement('a');
                                    // link.setAttribute('href', 'data:text/plain;charset=utf-8,' + content);
                                    // link.setAttribute('download', 'testrtc-' + (new Date().toJSON()) + '.log');
                                    // link.click();

                                    //$rootScope.$broadcast('showhide-testrtc', {value: false});
                                    buttons.querySelector('paper-button:last-child').click();
                                });
                            }
                        }
                        iframe.style.visibility = '';
                    }, 0);
                };
                iframe.src = testrtcUrl;
            }, 0);
        }

        function close() {
            logger.log('close', 'called');
            $rootScope.$broadcast('showhide-testrtc', { value: false });
        }
    }
]);
